module.exports = __webpack_public_path__ + "static/media/snoopyfrezzing01.fecb2182.jpg";